<div class="modal-signature-component">

  <div class="goback-btn" *ngIf="showConfirm || showError">
    <mat-icon class="icon-details" (click)="goBack()">arrow_back</mat-icon>
  </div>

  <div class="close-btn">
    <mat-icon (click)="closeClick()" svgIcon="close"></mat-icon>
  </div>

  <div mat-dialog-title>
    <div *ngIf="showError" class="recover-error"></div>
    <div [ngClass]="{ 'title-error' : showError }">
      {{ showError ? titleError : showConfirm ? titleConfirm : titleRecover }}
    </div>
  </div>

  <div mat-dialog-content>
    <div class="text">{{ showError ? contentError : showConfirm ? contentConfirm : contentRecover }}</div>
    <div class="email" *ngIf="!showConfirm && !showError">{{ data.email }}</div>
  </div>

  <div mat-dialog-actions>
    <div class="button-submit">
      <div class="button-progress">

        <div *ngIf="!showConfirm && !showError">
          <div id="spinnerDiv" [ngClass]="{ 'fadeIn': loading, 'fadeOut': !loading }" class="animated">
            <mat-spinner diameter="38" color="primary02"></mat-spinner>
          </div>
          <button
            [ngClass]="{ 'fadeIn': !loadingforgot, 'fadeOut': loadingforgot, 'error': !user , 'success': !loadingforgot && isUserLogged }"
            mat-raised-button color="primary01" class="animated" [disabled]="loadingforgot" (click)="send()">Enviar
          </button>
        </div>

        <div *ngIf="showConfirm && !showError">
          <img src="./assets/images/svg/send.svg" width="97.2px" height="97.2px">
        </div>
      </div>
    </div>

    <div class="contact-error" *ngIf="!showConfirm && showError">
      <div *ngIf="helpPhone1 && helpPhone1.phoneNumber != ''" class="contact-whatsapp">
        <div class="block-box"><img *ngIf="helpPhone1.isWhatsApp" src="./assets/images/svg/whatsapp-logo.svg" style="width: 29px;"></div>
        <span class="block-box contact-link" (click)="openWhatsappWindow()">{{ helpPhone1.phoneNumber }}</span>
      </div>
      <div class="contact-email">
        <div class="block-box"><img src="./assets/images/svg/email.svg" style="width: 29px;"></div>
        <a class="block-box contact-link" href="mailto:{{ helpEmail }}">{{ helpEmail }}</a>
      </div>
    </div>
  </div>

</div>